import { useRecoilValue, useSetRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { SubscriptionPaymentSucessful } from 'src/views/subscriptions/payment-success'
import { SubscriptionModalFooter } from 'src/views/subscriptions/footer'
import { SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS } from 'src/constants/subscriptions'

import * as paymentsAtoms from 'src/atoms/payments'

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  max-width: ${SUBSCRIPTION_MODAL_CONTENT_DIMENSIONS.width}px;
  margin: 0 auto;
`

export const Confirmation = () => {
  const paymentIntent = useRecoilValue(paymentsAtoms.paymentIntent)
  const setSubscribeModalOpen = useSetRecoilState(paymentsAtoms.subcribeModalOpen)

  const onGoToApp = async () => {
    setSubscribeModalOpen(false)
  }

  const onDownloadReceipt = () => {}

  if (!paymentIntent) {
    return null
  }

  return (
    <Wrapper>
      <SubscriptionPaymentSucessful
        date={paymentIntent.created}
        paidAmount={parseFloat((paymentIntent.amount / 100).toFixed(2))}
      />
      <SubscriptionModalFooter>
        <ButtonWithIcon onClick={onDownloadReceipt}>Download Receipt</ButtonWithIcon>
        <ButtonWithIcon inverted onClick={onGoToApp}>
          Done
        </ButtonWithIcon>
      </SubscriptionModalFooter>
    </Wrapper>
  )
}
